import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import EquipmentUtils from '../../utils/EquipmentUtils';
import EquipmentList from 'equipmentComponents/EquipmentList';
import FontIcon from 'material-ui/FontIcon';
import { ontFirmwareVersion } from '../../constants/houseEquipmentConfig';

class EquipmentPanel extends PureComponent {

    componentDidUpdate() { }

    render() {
        const {
            equipmentDetails,
            clearWorkOrderDetail,
            orderId,
            header,
            detailKey,
            techInventory,
            workOrderActions,
            sqcActions,
            sqcResults,
            schedulingSystemDetails,
            equipmentHitDetails,
            refreshHitDetails,
            customerDetails,
            houseEquipmentDetails
        } = this.props;
        let equipment = null,
            equipmentLoading = false,
            outletsUpdating = false,
            equipmentValidations = null,
            billingSystem = null,
            orderType = null,
            signalAccessCode = customerDetails.get("signalAccessCode");

        let outletUpdateMessage = null;
        let outletUpdatePendingMessage = null;
        if (equipmentDetails) {
            equipment = equipmentDetails.get('details');
            equipmentValidations = equipmentDetails.get('validators');
            equipmentLoading = equipmentDetails.get('loading');
            outletsUpdating = equipmentDetails.get('outletUpdateLoading');
            outletUpdateMessage = equipmentDetails.get('outletUpdateMessage');
            outletUpdatePendingMessage = equipmentDetails.get('outletUpdatePendingMessage');
        }

        if (schedulingSystemDetails) {
            billingSystem = schedulingSystemDetails.get('billingSystem');
            orderType = schedulingSystemDetails.get('serviceOrderInfoV2').get('serviceTypeId');
        }

        let removeCount = 0;
        let removeWarning = null;
        let provisioningMessage = null;
        let moveMessage = null;
        let ontActivationMessage = null;
        let eeroCommunityMessage = null;
        let isTransferMove = false;
        let isSikMoveTransfer = false;
        let isEmtaGatewayTransfer = false;
        let hasWHWF = false;
        let isWHWFUpgrade = false;
        let shouldShowONTMessage = false;
        let isEeroCommunity = false;


        const alertBarStyle = {
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            borderRadius: '4px',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
            color: 'white'
        };
        const iconStyle = { fontSize: '18px', color: 'white', marginRight: '8px' };

        if (outletsUpdating || outletUpdatePendingMessage) {
            let statusText = 'Refreshing equipment...';
            if (outletsUpdating && equipment) {
                const hasActivating = equipment.some(item => item.get('action') === 'add');
                const hasDeactivating = equipment.some(item => item.get('action') === 'remove');
                if (hasActivating && hasDeactivating) {
                    statusText = 'Performing equipment swap, please stand by...';
                } else if (hasActivating) {
                    statusText = 'Activating equipment, please stand by...';
                } else if (hasDeactivating) {
                    statusText = 'Deactivating equipment, please stand by...';
                } else {
                    statusText = 'Processing...';
                }
            }
            provisioningMessage = (
                <div style={Object.assign({}, alertBarStyle, { backgroundColor: '#1565c0' })}>
                    <FontIcon className="material-icons wow-fst-spin" style={iconStyle}>refresh</FontIcon>
                    <span>{statusText}</span>
                </div>
            );
        } else if (outletUpdateMessage && !outletUpdateMessage.includes('Unsuccessful')) {
            provisioningMessage = (
                <div style={Object.assign({}, alertBarStyle, { backgroundColor: '#2e7d32' })}>
                    <FontIcon className="material-icons" style={iconStyle}>check_circle</FontIcon>
                    <span>{outletUpdateMessage}</span>
                </div>
            );
        } else if (outletUpdateMessage) {
            provisioningMessage = (
                <div style={Object.assign({}, alertBarStyle, { backgroundColor: '#b71c1c' })}>
                    <FontIcon className="material-icons" style={iconStyle}>cancel</FontIcon>
                    <span>{outletUpdateMessage}</span>
                </div>
            );
        }

        if (equipment) {
            isSikMoveTransfer = EquipmentUtils.isSkinnyInstallMoveTransfer(equipment);
            hasWHWF = EquipmentUtils.hasWhwifiEquipment(equipment);
            isWHWFUpgrade = EquipmentUtils.isWHWFUpgrade(equipment);
            shouldShowONTMessage = EquipmentUtils.shouldShowONTMessage(equipment, signalAccessCode);
            isEeroCommunity = EquipmentUtils.isEeroCommunity(equipment, orderType);

            equipment.forEach((item) => {

                if (item.get('action') === 'remove') {
                    removeCount = removeCount += 1;
                }

                if (item.get('isTransferMove') === true) {
                    isTransferMove = true;
                }

                if (item.get('emtaGatewayTransferFlag') === true) {
                    isEmtaGatewayTransfer = true;
                }
            });

            if (shouldShowONTMessage) {
                ontActivationMessage = <p>Plug ONT into light and power for 4 minutes.
                    Once the 2nd light is green and blinking, check for the latest firmware
                    version ({ontFirmwareVersion}) in Cable Medic. If not on {ontFirmwareVersion}, reboot the ONT.
                    If 2nd green light is blinking AND the ONT is on {ontFirmwareVersion}, add the ONT to the account in FST.
                </p>
            }

            if (!isTransferMove && removeCount > 0 && removeCount === equipment.count()
                && !outletsUpdating && !outletUpdateMessage && !outletUpdatePendingMessage) {
                removeWarning = (
                    <div className="card-panel red darken-4 white-text">
                        <p>You are about to remove all equipment!</p>
                    </div>
                );
            }

            if (isTransferMove) {
                moveMessage = (
                    <div className="card-panel">
                        <p>To activate equipment on a move transfer, it must first be removed and then re-added.</p>
                        {ontActivationMessage}
                    </div>
                );
            }

            if (isEeroCommunity) {
                eeroCommunityMessage = (
                    <div className="card-panel">
                        <p>Eero devices on this account must be assigned the “Community” network type and network names should be named with “Street # Building # Apt/Unit #"</p>
                    </div>
                );
            }

            if (isSikMoveTransfer) {
                moveMessage = (
                    <div className="card-panel">
                        <p>This is a Move Transfer Skinny Install order.  To move the equipment from the old account
                            to the new account address, remove it to your tech ID in this screen and then re-add it from
                            this screen to move it to the new account address.  This will also provision the modem and make
                            it ready for the customer to hook it up to activate it.
                            You do not need to install or leave equipment behind for this order since the customer is
                            bringing the equipment with them from their previous address.  Leave a door tag with the move transfer
                            checkbox marked and leave a coax jumper with the door tag for the customer to connect their modem at
                            this new address.
                        </p>
                        {ontActivationMessage}
                    </div>
                );
            }

            if (isWHWFUpgrade && !isTransferMove) {
                moveMessage = (
                    <div className="card-panel">
                        <p>To activate equipment on the WHWF upgrade, the existing equipment must be first removed
                            and then add the new equipment.
                        </p>
                        {ontActivationMessage}
                    </div>);
            }

            if (!moveMessage && shouldShowONTMessage) {
                moveMessage = (<div className="card-panel">
                    {ontActivationMessage}
                </div>);
            }
        }

        const displayEquipment = equipment;

        const panelContents = (
            <div>
                {removeWarning}
                {provisioningMessage}
                {moveMessage}
                {eeroCommunityMessage}
                <EquipmentList
                    loading={equipmentLoading || outletsUpdating}
                    equipment={displayEquipment}
                    workOrderActions={workOrderActions}
                    orderId={orderId}
                    sqcActions={sqcActions}
                    sqcResults={sqcResults}
                    techInventory={techInventory}
                    billingSystem={billingSystem}
                    hasWHWF={hasWHWF}
                    equipmentHitDetails={equipmentHitDetails}
                    refreshHitDetails={refreshHitDetails}
                    equipmentValidations={equipmentValidations}
                    customerDetails={customerDetails}
                    houseEquipmentDetails={houseEquipmentDetails}
                    equipmentDetails={displayEquipment}
                />
            </div>
        );

        return (
            <Panel
                loading={equipmentLoading && !outletUpdatePendingMessage}
                hasDetails={equipment && equipment.count() > 0}
                orderId={orderId}
                detailKey={detailKey}
                clearWorkOrderDetail={clearWorkOrderDetail}
                header={header}
                hasNestedCollapse={true}>
                {panelContents}
            </Panel>
        );
    }
}

EquipmentPanel.propTypes = {
    workOrderActions: PropTypes.object,
    sqcResults: PropTypes.object,
    equipmentDetails: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    detailKey: PropTypes.string,
    techInventory: PropTypes.object,
    sqcActions: PropTypes.object,
    billingSystem: PropTypes.string,
    isSkinnyInstallType: PropTypes.bool
};

EquipmentPanel.contextTypes = {};
export default EquipmentPanel;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentPanel.js